import { combineReducers } from 'redux';
import { appReducer as app } from 'state/modules/app';
import entity from 'state/modules/entity';
import lessonPlanner from 'state/modules/lessonPlanner';
import messaging from 'state/modules/messaging';
import tour from 'state/modules/tour';
import ui from 'state/modules/ui';
import user from 'state/modules/user';

const rootReducer = combineReducers({
  app,
  entity,
  lessonPlanner,
  messaging,
  tour,
  ui,
  user
});

export default rootReducer;
